var _path, _line, _line2, _line3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMale(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.6827 15.8155C16.6827 18.5704 14.4494 20.8036 11.6946 20.8036C8.93972 20.8036 6.70647 18.5704 6.70647 15.8155C6.70647 13.0606 8.93972 10.8274 11.6946 10.8274C14.4494 10.8274 16.6827 13.0606 16.6827 15.8155Z",
    stroke: "#ED6E18",
    strokeWidth: 2
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 21.3471,
    y1: 6.91323,
    x2: 15.0912,
    y2: 12.9984,
    stroke: "#ED6E18",
    strokeWidth: 2
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 20.9688,
    y1: 6.90393,
    x2: 20.9688,
    y2: 13.8811,
    stroke: "#ED6E18",
    strokeWidth: 2
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 14.8035,
    y1: 7.33154,
    x2: 22.2935,
    y2: 7.33154,
    stroke: "#ED6E18",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMale);
export default __webpack_public_path__ + "static/media/Male.c1854bd6ff8098cfd5dd0d367d9055e6.svg";
export { ForwardRef as ReactComponent };